/**
 * Loader <-> iframe postMessage protocol (AGENTS.md 5.2).
 * Every message is `{ source: "wapadesk", type, payload }`.
 */
export const WIDGET_PROTOCOL_SOURCE = "wapadesk";
export const LOADER_TO_IFRAME_TYPES = ["init"];
export const IFRAME_TO_LOADER_TYPES = [
    "ready",
    "session",
    "close",
    "navigate",
    "resize",
    "state",
    "track",
];
export function isWidgetMessage(data) {
    return (typeof data === "object" &&
        data !== null &&
        data.source === WIDGET_PROTOCOL_SOURCE &&
        typeof data.type === "string");
}
/**
 * Live funnel preview (owner request, 14 October 2026): the dashboard opens the chat app at
 * `/preview` and sends it the unpublished draft. The preview never creates sessions, leads,
 * events or files.
 */
export const PREVIEW_SOURCE = "wapadesk-preview";
/** Dashboard origins allowed to drive the preview. */
export const PREVIEW_PARENT_ORIGINS = [
    "https://app.wapadesk.com",
    "https://app-staging.wapadesk.com",
    "http://localhost:3000",
    "http://127.0.0.1:3000",
];
export function isPreviewMessage(v) {
    return (typeof v === "object" &&
        v !== null &&
        v.source === PREVIEW_SOURCE &&
        typeof v.type === "string");
}
//# sourceMappingURL=protocol.js.map